import { StoryData, getStoryBySlug } from '@cinch-nx/data-storyblok'

import { PolicyPageStoryContent } from '../types/policy-page'

export const getPolicyPageContentData = async (
  slug: string,
  preview = false,
): Promise<StoryData<PolicyPageStoryContent> | undefined> => {
  const story = await getStoryBySlug<PolicyPageStoryContent>(
    `policies/${slug}`,
    {
      version: preview ? 'draft' : 'published',
      cv: Date.now(),
    },
  )

  return story ?? undefined
}
